<template>
  <div>
    <el-dialog
      title="Add a new Tip"
      :visible.sync="tipDialogVisible"
      width="50%">

      <el-form
        class="mktAct__form"
        ref="newTipForm"
        :model="newTip"
        :rules="tipRules"
        label-width="120px"
      >
      <el-form-item label="Status">
        <el-radio-group v-model="newTip.status">
          <el-radio-button label="Off"></el-radio-button>
          <el-radio-button label="Stand by"></el-radio-button>
          <el-radio-button label="On"></el-radio-button>
        </el-radio-group>
      </el-form-item>
        <el-form-item label="Banner name" prop="name">
          <el-input v-model="newTip.name"></el-input>
        </el-form-item>
        <el-form-item label="Partner Name" prop="techName">
          <el-input v-model="newTip.techName"></el-input>
        </el-form-item>
        <el-form-item class="mktAct__form__languages" label="Languages" ref="languages">
          <el-select
            v-model="newTip.languages"
            @change="onChangeLanguages"
            name="languages"
            filterable
            multiple
            placeholder=""
          >
            <el-option
              v-for="item in langOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <div class="mktAct__form__language" v-for="(lang, index) in newTip.languages">
            <el-collapse>
              <el-collapse-item :name="index + 1">

                <template slot="title">
                  {{lang}} ({{newTip.contents[lang] ? newTip.contents[lang].length : 0}})
                  <div class="mktAct__form__language__toolbar">
                    <i
                      @click="addLangContent(lang, $event)"
                      class="pointer toolbar__icon el-icon-plus mktAct__form__language__toolbar__btn mktAct__form__language__toolbar__btn--add"
                    ></i>
                    <i
                      @click="deleteTipLang(lang, $event)"
                      class="pointer toolbar__icon el-icon-delete mktAct__form__language__toolbar__btn mktAct__form__language__toolbar__btn--delete"
                    ></i>
                  </div>
                </template>
                <div class="mktAct__form__language__content" v-for="(newTipsData, idx) in newTip.contents[lang]">
                  <i
                    @click="deleteLangContent(lang, idx)"
                    class="pointer toolbar__icon el-icon-delete mktAct__form__language__toolbar__btn mktAct__form__language__toolbar__btn--delete"
                    v-bind:style="{ position: 'absolute' }"
                  ></i>
                  <!-- Title -->
                  <el-form-item
                  label="Title"
                  :prop="`contents[${lang}][${idx}].title`"
                  :rules="[
                    { required: true, message: 'Please input tips title', trigger: 'blur' },
                    { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                  ]"
                  >
                    <el-input v-model="newTip.contents[lang][idx].title"></el-input>
                  </el-form-item>
                  <!-- Content -->
                  <el-form-item
                  label="Content"
                  :prop="`contents[${lang}][${idx}].content`"
                  :rules="[
                    { required: true, message: 'Please input tips content', trigger: 'blur' },
                    { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                  ]"
                  >
                    <el-input type="textarea" v-model="newTip.contents[lang][idx].content"></el-input>
                  </el-form-item>
                  <!-- Call to action -->
                  <el-form-item
                  label="Call to action"
                  :prop="`contents[${lang}][${idx}].cta`"
                  :rules="[
                    { required: true, message: 'Please input tips call to action', trigger: 'blur' },
                    { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                  ]"
                  >
                    <el-input v-model="newTip.contents[lang][idx].cta"></el-input>
                  </el-form-item>
                  <!-- Addon url -->
                  <el-form-item
                  label="Addon url"
                  :prop="`contents[${lang}][${idx}].addonUrl`"
                  :rules="[
                    { required: true, message: 'Please input tips addon url', trigger: 'blur' }
                  ]"
                  >
                    <el-input v-model="newTip.contents[lang][idx].addonUrl"></el-input>
                  </el-form-item>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-form-item>
        <el-form-item class="mktAct__form__visibility" label="Visibility" ref="visibility">
          <el-select
            v-model="newTip.visibility"
            name="visibility"
            filterable
            multiple
            placeholder="Worldwide"
          >
            <el-option-group
              v-for="group in visibilityOptions"
              :key="group.label"
              :label="group.label">
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item class="mktAct__form__visibility__shortcut">
          <el-button v-on:click="newTip.visibility=zones.AF.concat(zones.AS, zones.EU, zones.NA, zones.OC, zones.SA)">Worldwide</el-button>
          <el-button type="info" v-on:click="newTip.visibility=zones.AF">Africa</el-button>
          <el-button type="warning" v-on:click="newTip.visibility=zones.AS">Asia</el-button>
          <el-button type="primary" v-on:click="newTip.visibility=zones.EU">Europe</el-button>
          <el-button type="danger" v-on:click="newTip.visibility=zones.NA">N. America</el-button>
          <el-button type="success" v-on:click="newTip.visibility=zones.OC">Oceania</el-button>
          <el-button type="danger" v-on:click="newTip.visibility=zones.SA">S. America</el-button>
          <el-button v-on:click="newTip.visibility=['']"><i class="toolbar__icon el-icon-close"></i></el-button>
        </el-form-item>
        <el-form-item label="Logo" class="mktAct__form__logo">
          <el-upload
            class="upload-demo"
            :action="`${apiUrl}/activities/logo`"
            ref="logoUpload"
            :on-change="onChangeLogo"
            :auto-upload="false"
            :multiple="false"
            :limit="1"
            list-type="picture">
            <el-button size="small" type="primary">Click to upload</el-button>
            <div slot="tip" class="el-upload__tip">png file with a size less than 500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="addTip"
          :loading="saving === true"
        >
          Confirm
        </el-button>
        <el-button @click="resetForm('newTipForm')">Reset</el-button>
      </span>
    </el-dialog>

    <el-row :gutter="24">
      <el-col :span="14" :offset="5">

        <div class="grid-content">
          <div class="mainToolbar pull-right">
            <i @click="tipDialogVisible = true; deletion.active = false; editing = false" class="pointer mainToolbar__icon el-icon-plus"></i>
            <i @click="deletion.active = !deletion.active; editing = false" class="pointer mainToolbar__icon el-icon-delete"></i>
          </div>
          <div class="breadcrumb">
            <h1 class="breadcrumb__h1">Marketing Activities</h1>
            <h1 class="breadcrumb__h2">Tips of the day</h1>
          </div>
        </div>
        <div class="grid-content">
          <el-input
            class="searchContent"
            placeholder="Search"
            prefix-icon="el-icon-search"
            @keyup.native="seachActivity">
          </el-input>
        </div>
        <el-collapse class="filtersCollapse">
          <el-collapse-item title="Filters" name="1">
            <div class="grid-content filtersCollapse__tabpanel">
              <el-form ref="form" :model="filter" label-width="120px">
                <el-form-item label="Languages">
                  <el-select
                    v-model="filter.languages"
                    @change="onChangeLanguages"
                    name="languages"
                    filterable
                    multiple
                    placeholder="All languages"
                  >
                    <el-option
                      v-for="item in langOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Countries">
                  <el-select
                    v-model="filter.countries"
                    name="visibility"
                    filterable
                    multiple
                    placeholder="Worldwide"
                  >
                    <el-option-group
                      v-for="group in visibilityOptions"
                      :key="group.label"
                      :label="group.label">
                      <el-option
                        v-for="item in group.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item>
                <el-form-item class="mktAct__form__visibility__shortcut">
                  <el-button v-on:click="filter.countries=zones.AF.concat(zones.AS, zones.EU, zones.NA, zones.OC, zones.SA)">Worldwide</el-button>
                  <el-button type="info" v-on:click="filter.countries=zones.AF">Africa</el-button>
                  <el-button type="warning" v-on:click="filter.countries=zones.AS">Asia</el-button>
                  <el-button type="primary" v-on:click="filter.countries=zones.EU">Europe</el-button>
                  <el-button type="danger" v-on:click="filter.countries=zones.NA">N. America</el-button>
                  <el-button type="success" v-on:click="filter.countries=zones.OC">Oceania</el-button>
                  <el-button type="danger" v-on:click="filter.countries=zones.SA">S. America</el-button>
                  <el-button v-on:click="filter.countries=['']"><i class="toolbar__icon el-icon-close"></i></el-button>
                </el-form-item>
                <el-form-item label="Status">
                  <el-checkbox-group v-model="filter.status">
                    <el-checkbox label="Off" border></el-checkbox>
                    <el-checkbox label="Stand by" border></el-checkbox>
                    <el-checkbox label="On" border></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item class="filtersCollapse__tabpanel__applyBlock">
                  <el-button type="primary" @click="onApplyFilters">Apply</el-button>
                  <el-button @click="onClearFilters">Clear</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="grid-content pageContent" v-if="deletion.active">
          <el-button
            @click="deleteActivities"
            v-show="deletion.activities.length"
            :loading="deletion.activities.loading === true"
            type="danger"
            plain
          >
            Delete
          </el-button>
          <el-button v-show="!deletion.activities.length" type="danger" plain disabled>Delete</el-button>
          <el-button @click="deletion.active = false" plain>Cancel</el-button>
        </div>

        <el-row :gutter="24" class="pageContent">
          <el-col :span="24">
            <div v-show="!tips.length" class="spinner">
              <div class="double-bounce1"></div>
              <div class="double-bounce2"></div>
            </div>
            <div v-for="(tip, index) in tips">
              <div
                class="mktAct"
                v-bind:class="{
                  'mktAct--active': tip.status==='On',
                  'mktAct--pending': tip.status==='Stand by',
                  'mktAct--editing': editing===index
                }"
                v-show="search.hiddenActivities.indexOf(index) === -1 && filter.hiddenActivities.indexOf(index) === -1"
              >
                <div class="mktAct__header" v-on:click="editing = editing === false ? index : false">
                  <div class="mktAct__header__logo" :style="{ backgroundImage: `url('${tip.logoUrl}')` }"></div>
                  <h1 class="mktAct__header__partnerName">{{ tip.name }}</h1>
                  <el-checkbox @change="onChangeDeleteCheckbox(index, $event)" v-if="deletion.active" class="mktAct__header__deleteCheckbox"></el-checkbox>
                </div>
                <div v-if="editing===index" class="mktAct__edit">
                  <el-form class="mktAct__form" ref="form" :model="tip" label-width="120px">
                    <el-form-item label="Status">
                      <el-radio-group v-model="tip.status">
                        <el-radio-button label="Off"></el-radio-button>
                        <el-radio-button label="Stand by"></el-radio-button>
                        <el-radio-button label="On"></el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="Banner name" prop="name">
                      <el-input v-model="tip.name"></el-input>
                    </el-form-item>
                    <el-form-item label="Partner Name">
                      <el-input v-model="tip.techName"></el-input>
                    </el-form-item>
                    <el-form-item class="mktAct__form__languages" label="Languages" ref="languages">
                      <el-select
                        v-model="tip.languages"
                        @change="onChangeLanguages"
                        name="languages"
                        filterable
                        multiple
                        placeholder=""
                      >
                        <el-option
                          v-for="item in langOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="">
                      <div class="mktAct__form__language" v-for="(lang, index) in tip.languages">
                        <el-collapse>
                          <el-collapse-item :name="index + 1">

                            <template slot="title">
                              {{lang}} ({{tip.contents[lang] ? tip.contents[lang].length : 0}})
                              <div class="mktAct__form__language__toolbar">
                                <i
                                  @click="addLangContent(lang, $event)"
                                  class="pointer toolbar__icon el-icon-plus mktAct__form__language__toolbar__btn mktAct__form__language__toolbar__btn--add"
                                ></i>
                                <i
                                  @click="deleteTipLang(lang, $event)"
                                  class="pointer toolbar__icon el-icon-delete mktAct__form__language__toolbar__btn mktAct__form__language__toolbar__btn--delete"
                                ></i>
                              </div>
                            </template>
                            <div class="mktAct__form__language__content" v-for="(tipsData, idx) in tip.contents[lang]">
                              <i
                                @click="deleteLangContent(lang, idx)"
                                class="pointer toolbar__icon el-icon-delete mktAct__form__language__toolbar__btn mktAct__form__language__toolbar__btn--delete"
                                v-bind:style="{ position: 'absolute' }"
                              ></i>
                              <!-- Title -->
                              <el-form-item
                              label="Title"
                              :prop="`contents[${lang}][${idx}].title`"
                              :rules="[
                                { required: true, message: 'Please input tips title', trigger: 'blur' },
                                { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                              ]"
                              >
                                <el-input v-model="tip.contents[lang][idx].title"></el-input>
                              </el-form-item>
                              <!-- Content -->
                              <el-form-item
                              label="Content"
                              :prop="`contents[${lang}][${idx}].content`"
                              :rules="[
                                { required: true, message: 'Please input tips content', trigger: 'blur' },
                                { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                              ]"
                              >
                                <el-input type="textarea" v-model="tip.contents[lang][idx].content"></el-input>
                              </el-form-item>
                              <!-- Call to action -->
                              <el-form-item
                              label="Call to action"
                              :prop="`contents[${lang}][${idx}].cta`"
                              :rules="[
                                { required: true, message: 'Please input tips call to action', trigger: 'blur' },
                                { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                              ]"
                              >
                                <el-input v-model="tip.contents[lang][idx].cta"></el-input>
                              </el-form-item>
                              <!-- Addon url -->
                              <el-form-item
                              label="Addon url"
                              :prop="`contents[${lang}][${idx}].addonUrl`"
                              :rules="[
                                { required: true, message: 'Please input tips addon url', trigger: 'blur' }
                              ]"
                              >
                                <el-input v-model="tip.contents[lang][idx].addonUrl"></el-input>
                              </el-form-item>
                            </div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                    </el-form-item>
                    <el-form-item class="mktAct__form__visibility" label="Visibility" ref="visibility">
                      <el-select
                        v-model="tip.visibility"
                        name="visibility"
                        filterable
                        multiple
                        placeholder="Worldwide"
                      >
                        <el-option-group
                          v-for="group in visibilityOptions"
                          :key="group.label"
                          :label="group.label">
                          <el-option
                            v-for="item in group.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </el-form-item>
                    <el-form-item class="mktAct__form__visibility__shortcut">
                      <el-button v-on:click="tip.visibility=zones.AF.concat(zones.AS, zones.EU, zones.NA, zones.OC, zones.SA)">Worldwide</el-button>
                      <el-button type="info" v-on:click="tip.visibility=zones.AF">Africa</el-button>
                      <el-button type="warning" v-on:click="tip.visibility=zones.AS">Asia</el-button>
                      <el-button type="primary" v-on:click="tip.visibility=zones.EU">Europe</el-button>
                      <el-button type="danger" v-on:click="tip.visibility=zones.NA">N. America</el-button>
                      <el-button type="success" v-on:click="tip.visibility=zones.OC">Oceania</el-button>
                      <el-button type="danger" v-on:click="tip.visibility=zones.SA">S. America</el-button>
                      <el-button v-on:click="tip.visibility=['']"><i class="toolbar__icon el-icon-close"></i></el-button>
                    </el-form-item>
                    <el-form-item label="Logo" class="mktAct__form__logo">
                      <el-upload
                        class="upload-demo"
                        :action="`${apiUrl}/tips/logo`"
                        :ref="`logoUpload${index}`"
                        :on-change="onChangeLogo"
                        :auto-upload="false"
                        :multiple="false"
                        :limit="1"
                        list-type="picture">
                        <el-button size="small" type="primary">Click to upload</el-button>
                        <div slot="tip" class="el-upload__tip">png file with a size less than 500kb</div>
                      </el-upload>
                    </el-form-item>


                    <el-form-item>
                      <el-button
                        type="primary"
                        :loading="saving === editing"
                        @click="updateTip"
                      >Save</el-button>
                      <el-button v-on:click="editing=false">Cancel</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios';
import languagesList from '../utils/languages';
import { zones, countriesListByRegion } from '../utils/countries';

export default {
  name: 'Tips',
  data() {
    return {
      env: process.env, // Environement variables
      deletion: {
        activities: [],
        loading: false,
        active: false,
      },
      search: {
        hiddenActivities: [],
        query: '',
      },
      langOptions: languagesList,
      zones,
      visibilityOptions: countriesListByRegion,
      tips: [],
      editing: false,
      saving: false,
      tipDialogVisible: false,
      newTip: {
        status: 'Off',
        name: '',
        techName: '',
        languages: ['EN'],
        contents: {
          EN: [
            {
              title: '',
              content: '',
              cta: 'More information?',
              addonUrl: '',
            },
          ],
        },
        visibility: [],
      },
      tipRules: {
        name: [
          { required: true, message: 'Please input Activity name', trigger: 'blur' },
        ],
        techName: [
          { required: true, message: 'Please input Activity partner name', trigger: 'blur' },
        ],
        content: [
          {
            required: true, message: 'Please input a content or remove this language', trigger: 'blur',
          },
          {
            max: 80, message: 'length should be less than 80', trigger: 'blur',
          },
        ],
      },
      filter: {
        languages: [],
        countries: [],
        hiddenActivities: [],
        status: ['Off', 'Stand by', 'On'],
      },
    };
  },
  mounted() {
    // Get the Tips list
    axios({
      method: 'GET',
      url: `${this.apiUrl}/tips`,
      headers: {
        Authorization: this.$idToken,
      },
    })
    .then((result) => {
      console.log('result:', result);
      this.tips = result.data;
    }, (error) => {
      console.error(error);
    });
  },
  methods: {
    /**
     * When the user type a seach, filter the activities by matching name or
     * tech id
     * @param {Event} e
     */
    seachActivity(e) {
      const query = e.target.value.toLowerCase();
      const matchs = [];
      for (let i = 0; i < this.tips.length; i++) {
        const name = this.tips[i].name.toLowerCase();
        const techName = this.tips[i].techName.toLowerCase();
        if (name.indexOf(query) === -1 && techName.indexOf(query) === -1) {
          matchs.push(i);
        }
      }

      this.search.hiddenActivities = matchs;
    },
    /**
     * Reset the form
     */
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.newTip = {
        isLive: false,
        name: '',
        techName: '',
        languages: ['EN'],
        contents: {
          EN: [
            {
              title: '',
              content: '',
              cta: 'More information?',
              addonUrl: '',
            },
          ],
        },
        visibility: [],
      };
      // Clear the uploaded file list
      this.$refs.logoUpload.clearFiles();
    },
    /**
     * addTip
     */
    addTip() {
      console.log('In addTip');
      // Set the loading state on the submit btn
      this.saving = true;

      const data = new FormData();
      data.append('activity', JSON.stringify(this.newTip));

      // If there is a logo to upload
      if (this.$refs.logoUpload.uploadFiles[0]) {
        // Get the file for the logo
        data.append('file', this.$refs.logoUpload.uploadFiles[0].raw);
      }

      // Insert an activity
      axios({
        method: 'POST',
        url: `${this.apiUrl}/tips`,
        data,
        headers: {
          Authorization: this.$idToken,
          'content-type': 'multipart/form-data',
        },
      })
      .then((result) => {
        // Unset the loading state on the submit btn
        this.saving = false;

        // Clear the uploaded file list
        this.resetForm('newTipForm');
        // Close the modal
        this.tipDialogVisible = false;

        // Notify the user that the creation was successfull
        this.$notify.success({
          title: 'Successfull insert',
          message: 'The new tips has been added',
        });

        // Update the tip list
        axios({
          method: 'GET',
          url: `${this.apiUrl}/tips`,
          headers: {
            Authorization: this.$idToken,
          },
        })
        .then((tips) => {
          this.tips = tips.data;
        }, (error) => {
          console.error(error);
        });
      })
      .catch((error) => {
        // Unset the loading state on the submit btn
        this.saving = false;

        const activity = JSON.parse(data.get('activity'));
        switch (error.response.status) {
          case 401:
            // 401 Unauthorized
            this.$notify.error({
              title: 'Error',
              message: 'You are not authorized to add a new activity',
            });
            break;
          case 403:
            // 403 Forbidden
            this.$notify.error({
              title: 'Error',
              message: `Non-existent bucket or you don't have the permission to
              use it. Please contact your administrator`,
            });
            break;
          case 409:
            // 409 Conflict
            this.$notify.error({
              title: 'Error',
              message: `An activity with the partner name "${activity.techName}"
              already exist`,
            });
            break;
          case 400:
            // Missing or wrong parameter
            if (error.message) {
              this.$notify.error({
                title: 'Error',
                message: 'Missing of wrong information submited',
              });
            }
            break;
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Unknow error. Please contact your administrator',
            });
            break;
        }
      });
    },
    /**
     * On click on a checkbox for the deletion of an activity, add / remove
     * this activity from this.deletion.activities
     * @param {Number} index - The index of the selected activity from this.tips
     * @param {Boolean} state - Whether or not the checkbox is checked
     */
    onChangeDeleteCheckbox(index, state) {
      if (state === true) {
        this.deletion.activities.push(index);
      } else {
        const pos = this.deletion.activities.indexOf(index);
        this.deletion.activities.splice(pos, 1);
      }
    },
    /**
     * Delete all the activities in the `this.deletion.activities` array
     */
    deleteActivities() {
      console.log('On deleteActivities');
      // Set the loading state to the submit button
      this.deletion.loading = true;

      // Get the Google Storage keys of the activities to remove
      const activityKeys = [];
      for (let i = 0; i < this.deletion.activities.length; i++) {
        activityKeys.push(this.tips[this.deletion.activities[i]].key);
      }

      const data = {
        keys: activityKeys,
      };

      axios({
        method: 'DELETE',
        url: `${this.apiUrl}/tips`,
        data,
        headers: {
          Authorization: this.$idToken,
          'content-type': 'application/json',
        },
      })
      .then((result) => {
        // Notify the user that the update was successfull
        this.$notify.success({
          title: 'Deletion successfull',
          message: 'The selected tips has been deleted',
        });

        // Hide the deletion UI
        this.deletion = {
          activities: [],
          loading: false,
          active: false,
        };

        // Update the tip list
        axios({
          method: 'GET',
          url: `${this.apiUrl}/tips`,
          headers: {
            Authorization: this.$idToken,
          },
        })
        .then((tips) => {
          this.tips = tips.data;
        }, (error) => {
          console.error(error);
        });
      })
      .catch((error) => {
        console.error(error);
        // Notify the user that an error occurred
        this.$notify.error({
          title: 'Error',
          message: 'An error has occurred, please contact the administrator',
        });

        this.deletion = {
          activities: [],
          loading: false,
          active: false,
        };
      });
    },
    /**
     * Triggers when the selected languages changes
     * @param {String} languages - current selected value
     */
    onChangeLanguages(languages) {
      // If we are editing an existing marketing activity
      if (this.editing !== false) {
        // Look for added language
        for (let i = 0; i < languages.length; i++) {
          if (!this.tips[this.editing].contents[languages[i]]) {
            this.$set(
              this.tips[this.editing].contents,
              languages[i],
              [{
                title: '',
                content: '',
                cta: '',
                addonUrl: '',
              }],
            );
          }
        }
      } else {
        // If editing a new marketing activity
        for (let i = 0; i < languages.length; i++) {
          if (!this.newTip.contents[languages[i]]) {
            this.$set(
              this.newTip.contents,
              languages[i],
              [{
                title: '',
                content: '',
                cta: '',
                addonUrl: '',
              }],
            );
          }
        }
      }
    },
    /**
     * Add a new tips form for the given language of the currently editing tips
     * @param {String} language
     * @param {Event} e
     */
    addLangContent(language, e) {
      e.stopPropagation();

      // If we are editing an existing marketing activity
      if (this.editing !== false) {
        this.tips[this.editing].contents[language].unshift({
          title: '',
          content: '',
          cta: '',
          addonUrl: '',
        });
      } else {
        // If editing a new marketing activity
        this.newTip.contents[language].unshift({
          title: '',
          content: '',
          cta: '',
          addonUrl: '',
        });
      }
    },
    /**
     * Remove the given content of the given language of the currently editing
     * tips
     * @param {String} language
     * @param {Number} index
     */
    deleteLangContent(language, index) {
      // If we are editing an existing marketing activity
      if (this.editing !== false) {
        this.tips[this.editing].contents[language].splice(index, 1);
      } else {
        // If editing a new marketing activity
        this.newTip.contents[language].splice(index, 1);
      }
    },
    /**
     * Remove all the content of the given language of the currently editing
     * tips
     * @param {String} language
     * @param {Event} e
     */
    deleteTipLang(language, e) {
      e.stopPropagation();

      delete this.tips[this.editing].contents[language];

      const index = this.tips[this.editing].languages.indexOf(language);
      this.tips[this.editing].languages.splice(index, 1);
    },
    /**
     * Handle the changes on the file input for the premium activation logo
     * @param {Object} file - The submited file
     * @param {Array} fileList - The list of files for this upload component
     */
    onChangeLogo(file, fileList) {
      const typeError = { title: 'Error', message: 'Only png files are allowed' };
      const dimError = { title: 'Error', message: 'The logo dimension must be 100x28 pixels' };
      const sizeError = { title: 'Error', message: 'The file size can\'t exceed 1 Mo' };

      // Check the type of the file
      if (file.raw.type !== 'image/png') {
        // Notify the user that an error occurred
        this.$notify.error(typeError);
        // Remove the file preview
        if (this.editing !== false) {
          this.$refs[`logoUpload${this.editing}`][0].clearFiles();
        } else {
          this.$refs.logoUpload.clearFiles();
        }
      }

      // Check dimensions of the uploaded image
      const reader = new FileReader();
      reader.onload = (e) => {
        const image = new Image();
        image.src = e.target.result;

        image.onload = () => {
          if (image.height !== 28 || image.width !== 100) {
            // Notify the user that an error occurred
            this.$notify.error(dimError);
            // Remove the file preview
            if (this.editing !== false) {
              // If editing an existing marketing activity
              this.$refs[`logoUpload${this.editing}`][0].clearFiles();
            } else {
              // If editing a new marketing activity
              this.$refs.logoUpload.clearFiles();
            }
          }
        };
      };
      reader.readAsDataURL(file.raw);
    },
    /**
     * Update the tip
     */
    updateTip() {
      console.log('In updateTip');
      // Set the loading state on the submit btn
      this.saving = this.editing;

      if (this.editing !== false && this.tips[this.editing]) {
        // Format the data to be send
        const data = new FormData();
        data.append('activity', JSON.stringify(this.tips[this.editing]));
        console.log('data:', data);

        // If there is a logo to upload
        if (this.$refs[`logoUpload${this.editing}`][0].uploadFiles[0]) {
          // Get the file for the logo
          data.append('file', this.$refs[`logoUpload${this.editing}`][0].uploadFiles[0].raw);
        }

        // Update an activity
        axios({
          method: 'PUT',
          url: `${this.apiUrl}/tips`,
          data,
          headers: {
            Authorization: this.$idToken,
            'content-type': 'multipart/form-data',
          },
        })
        .then((result) => {
          const tip = result.data;
          // Update the tip with the new data
          tip.logoUrl = `${tip.logoUrl}?${+new Date()}`;
          this.tips[this.editing] = tip;
          this.tips[this.editing].key = ['Tips', tip.name];

          // Notify the user that the update was successfull
          this.$notify.success({
            title: 'Update successfull',
            message: `${tip.name} has been updated`,
          });

          // Remove the file preview
          this.$refs[`logoUpload${this.editing}`][0].clearFiles();

          // Unset the loading state on the submit btn
          this.saving = false;

          // Close the tip edition panel
          this.editing = false;
        }, (error) => {
          console.error(error);
          // Unset the loading state on the submit btn
          this.saving = false;

          this.$notify.error({
            title: 'Error',
            message: 'An error has occurred, please contact the administrator',
          });
        });
      }
    },
    /**
     * Determine if an array contains one or more items from another array.
     * @param {array} haystack the array to search.
     * @param {array} arr the array providing items to check for in the haystack.
     * @return {boolean} true|false if haystack contains at least one item from arr.
     */
    findOne(haystack, arr) {
      return arr.some((v) => { // eslint-disable-line
        return haystack.indexOf(v) >= 0;
      });
    },
    /**
     * Apply the user filters
     */
    onApplyFilters() {
      const matchs = [];
      for (let i = 0; i < this.tips.length; i++) {
        const languages = this.tips[i].languages;
        const visibility = this.tips[i].visibility;
        const status = this.tips[i].status;

        // If there is a language filter
        if (
          this.filter.languages.length &&
          !this.findOne(languages, this.filter.languages)
        ) {
          matchs.push(i);
        }

        // If there is a country filter
        if (
          this.filter.countries.length &&
          this.filter.countries[0] !== '' &&
          !this.findOne(visibility, this.filter.countries)
        ) {
          matchs.push(i);
        }

        // If the status is not in the status filter
        if (!this.filter.status.includes(status)) {
          matchs.push(i);
        }
      }

      this.filter.hiddenActivities = matchs;
    },
    /**
     * Clear the filter form
     */
    onClearFilters() {
      this.filter = {
        languages: [],
        countries: [],
        hiddenActivities: [],
        status: ['Off', 'Stand by', 'On'],
      };
    },
  },
};
</script>

<style>
.el-dialog__body {
  text-align: left;
}
</style>

<style lang="sass" scoped>
  @import '../sass/variables'

  .el-select
    width: 100%
</style>



// WEBPACK FOOTER //
// src/components/Tips.vue